module.exports = __webpack_public_path__ + "img/cloud-computing.87b9876e.svg";